import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const ArrowSquareInIcon = ({ width = 39, height = 41 }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox="0 0 39 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="19.5" fill="#1DA83B" />
    <path
      d="M19.5001 21.25V27.25C19.5001 27.4489 19.421 27.6397 19.2804 27.7803C19.1397 27.921 18.949 28 18.7501 28C18.5511 28 18.3604 27.921 18.2197 27.7803C18.0791 27.6397 18.0001 27.4489 18.0001 27.25V23.0613L11.7807 29.2806C11.711 29.3503 11.6283 29.4056 11.5372 29.4433C11.4462 29.481 11.3486 29.5004 11.2501 29.5004C11.1515 29.5004 11.0539 29.481 10.9629 29.4433C10.8718 29.4056 10.7891 29.3503 10.7194 29.2806C10.6497 29.2109 10.5945 29.1282 10.5568 29.0372C10.519 28.9461 10.4996 28.8485 10.4996 28.75C10.4996 28.6515 10.519 28.5539 10.5568 28.4628C10.5945 28.3718 10.6497 28.2891 10.7194 28.2194L16.9388 22H12.7501C12.5511 22 12.3604 21.921 12.2197 21.7803C12.0791 21.6397 12.0001 21.4489 12.0001 21.25C12.0001 21.0511 12.0791 20.8603 12.2197 20.7197C12.3604 20.579 12.5511 20.5 12.7501 20.5H18.7501C18.949 20.5 19.1397 20.579 19.2804 20.7197C19.421 20.8603 19.5001 21.0511 19.5001 21.25ZM27.0001 11.5H15.0001C14.6022 11.5 14.2207 11.658 13.9394 11.9393C13.6581 12.2206 13.5001 12.6022 13.5001 13V17.5C13.5001 17.6989 13.5791 17.8897 13.7197 18.0303C13.8604 18.171 14.0511 18.25 14.2501 18.25C14.449 18.25 14.6397 18.171 14.7804 18.0303C14.921 17.8897 15.0001 17.6989 15.0001 17.5V13H27.0001V25H22.5001C22.3011 25 22.1104 25.079 21.9697 25.2197C21.8291 25.3603 21.7501 25.5511 21.7501 25.75C21.7501 25.9489 21.8291 26.1397 21.9697 26.2803C22.1104 26.421 22.3011 26.5 22.5001 26.5H27.0001C27.3979 26.5 27.7794 26.342 28.0607 26.0607C28.342 25.7794 28.5001 25.3978 28.5001 25V13C28.5001 12.6022 28.342 12.2206 28.0607 11.9393C27.7794 11.658 27.3979 11.5 27.0001 11.5Z"
      fill="white"
    />
  </SvgIcon>
);

ArrowSquareInIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ArrowSquareInIcon;
